module.exports = __webpack_public_path__ + "static/media/captions_Irish_Vandercook.d39036c0.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Irish_Vandercook.vtt
// module id = 120
// module chunks = 0